import { dataOn } from "../../main/data/data";
import { formatRefreshDateTime } from "./formatRefreshDateTime";
import { icons } from "./icons";
export function activeBoards() {
    dataOn("active", (data) => {
        const activeSection = document.querySelector("#active-pages .cp-active__content");
        const activeForm = document.querySelector(".cp-edit-urls__form");
        if (data) {
            const keys = Object.keys(data);
            let html = `<ul class="cp-active__list">`;
            let formHTML = ``;
            formHTML += `
                <div class="cp-edit-urls__form-container">
                    <select class="cp-edit-urls__select">
                        <option value="" selected disabled>Select a board</option>`;
            keys.forEach((key) => {
                const board = data[key];
                let ip = "";
                let urlGroup = "";
                let nextRefreshGroup = "";
                let lastRefreshGroup = "";
                let viewport = "";
                let screen = "";
                let refreshKey = "false";
                formHTML += `<option value="${key}">${key}</option>`;
                if (board.ip) {
                    ip = board.ip + "<br />";
                }
                if (board.viewport &&
                    board.viewport.width &&
                    board.viewport.height) {
                    viewport = `Viewport: ${board.viewport.width}x${board.viewport.height}`;
                }
                if (board.screen && board.screen.width && board.screen.height) {
                    screen = `Screen: ${board.screen.width}x${board.screen.height}`;
                }
                if (board.url) {
                    const url = new URL(board.url);
                    refreshKey = url.searchParams.get("pageId");
                    url.searchParams.delete("cachebuster");
                    url.searchParams.delete("pageId");
                    url.searchParams.delete("refresh");
                    urlGroup = `
                        <h5>URL config</h5>
                        <p><a href="${board.url}" target="_blank">${decodeURI(decodeURIComponent(url.search))}</a></p>`;
                }
                if (board.lastRefresh) {
                    lastRefreshGroup = `
                        <h5>Last refresh</h5>
                        <p>${formatRefreshDateTime(board.lastRefresh)}</p>`;
                }
                if (board.nextRefresh) {
                    nextRefreshGroup = `
                        <h5>Next refresh</h5>
                        <p>${formatRefreshDateTime(board.nextRefresh)}</p>`;
                }
                html += `
                    <li class="cp-active__item">
                        <div class="cp-active__main">
                            <div class="cp-active__main-group cp-active__main-group--end">
                                <h5>ID</h5>
                                <p>${key}</p>
                            </div>
                            <div class="cp-active__main-group cp-active__url">
                                ${urlGroup}
                            </div>
                            <div class="cp-active__main-group">
                                ${lastRefreshGroup}
                            </div>
                            <div class="cp-active__main-group">
                                ${nextRefreshGroup} 
                            </div>
                            <div class="cp-active__main-group cp-active__controls">
                                <button class="cp-active__refresh" data-key="${refreshKey}" data-url="${board.url}">
                                    ${icons().refresh}
                                </button>
                                <button class="cp-active__delete" data-key="${key}">
                                    ${icons().delete}
                                </button>
                            </div>
                        </div>
                        <p class="cp-active__meta">
                            ${ip}
                            ${screen} ${viewport}<br />
                            ${board.userAgent}
                        </p>
                    </li>
                `;
            });
            activeSection.innerHTML = html + "</ul>";
            activeForm.innerHTML =
                formHTML +
                    `
                    </select>
                    <input type="text" placeholder="Select bulletin board to begin..." class="cp-edit-urls__url" />
                </div>
                <p>
                    <button class="cp-edit-urls__submit cp__btn">
                        Submit
                    </button>
                    <span class="cp-edit-urls__status"></span>
                </p>
            `;
        }
        else {
            activeSection.innerHTML = `<p class="cp-empty">Sorry, we couldn't find any active boards at this time.</p>`;
            activeForm.innerHTML = `<p class="cp-empty">Sorry, we couldn't find any active boards at this time.</p>`;
        }
    });
}
